import { combineReducers } from 'redux';
import main from './reducers/mainReducer';
import comments from './reducers/commentsReducer';
import favorites from './reducers/favoritesReducer';
import startPage from './reducers/startPageReducer';

export default combineReducers({
  main,
  comments,
  favorites,
  startPage,
});
